import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { updateLLMUsageTier } from "../graphql/mutations";
import {
  UpdateLLMUsageTierInput,
  UpdateLLMUsageTierMutation,
  LLMUsageTierStatus,
} from "../API";

export async function updateLLMUsageTierAfterEdit(
  values: UpdateLLMUsageTierInput
): Promise<GraphQLResult<UpdateLLMUsageTierMutation>> {
  const nowIso = new Date().toISOString();
  const isActivating = values.status === LLMUsageTierStatus.ACTIVE;
  const isDeactivating = values.status === LLMUsageTierStatus.INACTIVE;
  return API.graphql(
    graphqlOperation(updateLLMUsageTier, {
      input: {
        id: values.id,
        projectId: values.projectId,
        status: values.status,
        name: values.name,
        description: values.description || "",
        // Versioning & lineage (pass-through; usually backend controls these for clones/activation flows)
        version: values.version ?? undefined,
        activeAt: values.activeAt ?? (isActivating ? nowIso : undefined),
        inactiveAt: values.inactiveAt ?? (isDeactivating ? nowIso : undefined),
        priorUsageTierId: values.priorUsageTierId ?? undefined,
        baseUsageTierId: values.baseUsageTierId ?? undefined,
        replenishmentPeriod: values.replenishmentPeriod,
        replenishmentMethod: values.replenishmentMethod,
        usageLimitAction: values.usageLimitAction,
        standardTokenReplenishmentAmount: values.standardTokenReplenishmentAmount || 0,
        premiumTokenReplenishmentAmount: values.premiumTokenReplenishmentAmount || 0,
        superPremiumTokenReplenishmentAmount: values.superPremiumTokenReplenishmentAmount || 0,
        reasoningTokenReplenishmentAmount: values.reasoningTokenReplenishmentAmount || 0,
        standardCallReplenishmentAmount: values.standardCallReplenishmentAmount || 0,
        premiumCallReplenishmentAmount: values.premiumCallReplenishmentAmount || 0,
        superPremiumCallReplenishmentAmount: values.superPremiumCallReplenishmentAmount || 0,
        reasoningCallReplenishmentAmount: values.reasoningCallReplenishmentAmount || 0,
        standardTokenUnlimited: values.standardTokenUnlimited ?? false,
        premiumTokenUnlimited: values.premiumTokenUnlimited ?? false,
        superPremiumTokenUnlimited: values.superPremiumTokenUnlimited ?? false,
        reasoningTokenUnlimited: values.reasoningTokenUnlimited ?? false,
        standardCallUnlimited: values.standardCallUnlimited ?? false,
        premiumCallUnlimited: values.premiumCallUnlimited ?? false,
        superPremiumCallUnlimited: values.superPremiumCallUnlimited ?? false,
        reasoningCallUnlimited: values.reasoningCallUnlimited ?? false,
      },
    })
  ) as Promise<GraphQLResult<UpdateLLMUsageTierMutation>>;
}
